export const rem = (size: number) => size * 10
